import { capitalizeFirstLetter } from "@sscs/utils";
const heightIncrement = 30;
const transformValue = (value, transformation) => {
    switch (transformation) {
        case "READABLE":
            return Math.log2(value) + 1;
        case "ACCURATE":
            return value;
    }
};
export const transformData = (inputData, transformation) => {
    let estimatedHeight = 0;
    const result = {
        nodes: [],
        links: [],
    };
    if (inputData === undefined)
        return { data: result, height: estimatedHeight };
    Object.keys(inputData).forEach((category) => {
        const categoryNode = { id: capitalizeFirstLetter(category), totalCount: 0 };
        inputData[category].forEach((statistic) => {
            const statID = `${statistic.type}/${statistic.subtype}`;
            const typeNode = result.nodes.find((node) => node.id === statID);
            if (typeNode === undefined)
                result.nodes.push({ id: statID, totalCount: Number(statistic.count) });
            else
                typeNode.totalCount += Number(statistic.count);
            categoryNode.totalCount += Number(statistic.count);
            result.links.push({
                source: capitalizeFirstLetter(category),
                target: statID,
                value: transformValue(Number(statistic.count), transformation),
                originalValue: Number(statistic.count),
            });
            estimatedHeight += heightIncrement;
            Object.keys(statistic.formats).forEach((format) => {
                if (format.toLowerCase() !== "unknown") {
                    const formatNode = result.nodes.find((node) => node.id === format);
                    if (formatNode === undefined) {
                        result.nodes.push({
                            id: format,
                            totalCount: Number(statistic.formats[format]),
                        });
                    }
                    else {
                        formatNode.totalCount += Number(statistic.formats[format]);
                    }
                    result.links.push({
                        source: statID,
                        target: format,
                        value: transformValue(Number(statistic.formats[format]), transformation),
                        originalValue: Number(statistic.formats[format]),
                    });
                    estimatedHeight += heightIncrement;
                }
            });
        });
        result.nodes.push(categoryNode);
    });
    return { data: result, height: estimatedHeight };
};
export const selectSubTree = (inputData, selected) => {
    let estimatedHeight = 0;
    const result = {
        nodes: [],
        links: [],
    };
    const insertNode = (link) => {
        const sourceNode = result.nodes.find((node) => node.id === link.source);
        const targetNode = result.nodes.find((node) => node.id === link.target);
        if (!sourceNode) {
            result.nodes.push({ id: link.source, totalCount: link.originalValue });
            estimatedHeight += heightIncrement;
        }
        if (!targetNode) {
            result.nodes.push({ id: link.target, totalCount: link.originalValue });
            estimatedHeight += heightIncrement;
        }
    };
    inputData.nodes.forEach((node) => {
        if ((selected.type === "LINK" &&
            (node.id === selected.source || node.id === selected.target)) ||
            (selected.type === "NODE" && node.id === selected.id)) {
            result.nodes.push({ ...node });
            estimatedHeight += heightIncrement;
        }
    });
    inputData.links.forEach((link) => {
        if (selected.type === "NODE" &&
            (link.source === selected.id || link.target === selected.id)) {
            result.links.push({ ...link });
            insertNode(link);
        }
        else if (selected.type === "LINK") {
            if (link.source === selected.source && link.target === selected.target) {
                result.links.push({ ...link });
                insertNode(link);
            }
            else if (link.target === selected.source ||
                link.source === selected.target) {
                result.links.push({ ...link });
                insertNode(link);
            }
        }
    });
    return { data: result, height: estimatedHeight };
};
export function isNode(value) {
    return value.id !== undefined;
}
//# sourceMappingURL=dataUtils.js.map